exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.div_founds {\n  background-color: #ffffff;\n  border-radius: 3px;\n  position: absolute;\n  height: auto;\n  width: 92%;\n  z-index: 9999;\n  box-shadow: 0px 3px 3px #ccc;\n}\n", ""]);

// exports
